import React from 'react'
import {
  CaretDown,
  CaretLeft,
  CaretRight,
  MagnifyingGlass,
} from '@phosphor-icons/react'
import moment from 'moment'
import { leagueGamesStore } from 'state/league/leageGames'
import { leaguePracticeStore } from 'state/league/leaguePractice'
import { leagueEventStore } from 'state/league/leagueEvent'
import { ViewMode } from './index'

interface FiltersProps {
  weekStart: moment.Moment
  setWeekStart: (d: moment.Moment) => void
  viewMode: ViewMode
  setViewMode: (m: ViewMode) => void
  activeTab: 'games' | 'practices' | 'constraints'
  setActiveTab: (tab: 'games' | 'practices' | 'constraints') => void
}

const Filters: React.FC<FiltersProps> = ({
  weekStart,
  setWeekStart,
  viewMode,
  setViewMode,
  activeTab,
  setActiveTab,
}) => {
  const { setAddGameModal, setSelectedGame } = leagueGamesStore(store => ({
    setAddGameModal: store.setAddGameModal,
    setSelectedGame: store.setSelectedGame,
  }))
  const { setAddPracticeModal, setSelectedPractice } = leaguePracticeStore(
    store => ({
      setAddPracticeModal: store.setAddPracticeModal,
      setSelectedPractice: store.setSelectedPractice,
    }),
  )
  const { setAddTeamConstraintModal } = leagueEventStore(store => ({
    setAddTeamConstraintModal: store.setAddTeamConstraintModal,
  }))

  const weekEnd = weekStart.clone().add(6, 'days')
  const weekLabel =
    weekStart.month() === weekEnd.month()
      ? `${weekStart.format('D')} - ${weekEnd.format('D MMM')}`
      : `${weekStart.format('D MMM')} - ${weekEnd.format('D MMM')}`

  const handlePrev = () => setWeekStart(weekStart.clone().subtract(1, 'week'))
  const handleNext = () => setWeekStart(weekStart.clone().add(1, 'week'))
  const toggleView = () => setViewMode(viewMode === 'week' ? 'day' : 'week')

  const handleAddGame = () => {
    setSelectedGame(null)
    setAddGameModal(true)
  }

  const handleAddPractice = () => {
    setSelectedPractice(null)
    setAddPracticeModal(true)
  }

  return (
    <>
      {/* Games / Practices / Constraints tab row */}
      <div className="sch-tab-row">
        <button
          className={`sch-tab-btn ${activeTab === 'games' ? 'sch-tab-active' : ''}`}
          onClick={() => setActiveTab('games')}
        >
          Games
        </button>
        <button
          className={`sch-tab-btn ${activeTab === 'practices' ? 'sch-tab-active' : ''}`}
          onClick={() => setActiveTab('practices')}
        >
          Practices
        </button>
        <button
          className={`sch-tab-btn ${activeTab === 'constraints' ? 'sch-tab-active' : ''}`}
          onClick={() => setActiveTab('constraints')}
        >
          Constraints
        </button>
      </div>

      {/* Search + action buttons */}
      <div className="filter-container">
        <div className="filter-search-container">
          <input
            type="search"
            className="search-input-group"
            placeholder="Search"
            onChange={e => e.preventDefault()}
          />
          <MagnifyingGlass size={20} color="#9CA5B0" className="search-icon" />
        </div>

        <div className="btn-container">
          <button className="buton btn-more buton-secondary">
            More
            <CaretDown size={16} color="#000" />
          </button>
          {activeTab === 'games' && (
            <>
              <button className="buton btn-day buton-primary" onClick={toggleView}>
                {viewMode === 'week' ? 'Week' : 'Day'}
                <CaretDown size={16} color="#2BA7CA" />
              </button>
              <button className="buton buton-primary" onClick={handleAddGame}>
                Add a game
              </button>
            </>
          )}
          {activeTab === 'practices' && (
            <button className="buton buton-primary" onClick={handleAddPractice}>
              Add a practice
            </button>
          )}
          {activeTab === 'constraints' && (
            <button
              className="buton buton-secondary"
              onClick={() => setAddTeamConstraintModal(true)}
            >
              Add constraint
            </button>
          )}
        </div>
      </div>

      {/* Date navigator — games only */}
      {activeTab === 'games' && (
        <div className="filter-date-container">
          <div className="filter-by">
            <h3>Filter by:</h3>
            <button className="filter-butn">
              Team
              <CaretDown size={16} color="#000" />
            </button>
          </div>
          {viewMode === 'week' ? (
            <div className="date-container">
              <h3>{weekLabel}</h3>
              <div className="btn-conainer">
                <CaretLeft size={24} color="#000" onClick={handlePrev} className="pointer" />
                <CaretRight size={24} color="#000" onClick={handleNext} className="pointer" />
              </div>
            </div>
          ) : (
            <div className="date-container">
              <h3>{weekStart.format('MMMM YYYY')}</h3>
              <div className="btn-conainer">
                <CaretLeft
                  size={24}
                  color="#000"
                  onClick={() => setWeekStart(weekStart.clone().subtract(1, 'month'))}
                  className="pointer"
                />
                <CaretRight
                  size={24}
                  color="#000"
                  onClick={() => setWeekStart(weekStart.clone().add(1, 'month'))}
                  className="pointer"
                />
              </div>
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default Filters
